module.exports = __webpack_public_path__ + "static/media/TP_Icon_EyeMask.a00675b1.png";